// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "voice_embedding".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "voice_embedding" table (1:1 with a DB row, on the wire). */
export const voiceEmbeddingAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaAdsPageId: z.string().nullable(),
    customerMessage: z.string(),
    businessReply: z.string(),
    embedding: z.array(z.number()),
    messageTimestamp: z.string().datetime().nullable(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=voiceEmbedding.js.map